var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "a-modal", class: _vm.classes, on: { click: _vm.hide } },
        [
          _c(
            "div",
            { staticClass: "modal-inner", on: { click: _vm.stopEvent } },
            [
              _c("div", { staticClass: "modal-header" }, [
                _vm.title
                  ? _c("h2", {
                      attrs: { title: _vm.title },
                      domProps: { textContent: _vm._s(_vm.title) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.enableClose
                  ? _c(
                      "div",
                      { staticClass: "close-button", on: { click: _vm.hide } },
                      [_c("CloseIcon")],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [_vm._t("default")], 2),
              _vm._v(" "),
              _vm.hasActions
                ? _c(
                    "div",
                    { staticClass: "modal-actions" },
                    [
                      _vm.hasActionsInSlot
                        ? _vm._t("actions")
                        : _vm.actions.length > 0
                        ? _vm._l(_vm.actions, function (action, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "action",
                                class: _vm.getClasses(action),
                                attrs: { title: action.label },
                                on: {
                                  click: (event) =>
                                    _vm.callHandler(event, action),
                                },
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(action.label) +
                                    "\n        "
                                ),
                              ]
                            )
                          })
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }